import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './modules/App/App';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import store from "./core/redux/Store";
import ErrorBoundary from "./shared/ErrorBoundary/ErrorBoundary";

ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </Provider>
    </ErrorBoundary>,
    document.getElementById('root')
);
